import {Injectable} from '@angular/core';
import {PreloadingStrategy, Route} from '@angular/router';
import {mergeMap, Observable, of, timer} from 'rxjs';
import {Logger} from '@ccp/lib/logger';

@Injectable({providedIn: 'root'})
export class SelectivePreloadStrategy implements PreloadingStrategy {
  public preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (route.data?.['preload'] === true) {
      const delay = route.data?.['preloadDelay'] || 0;

      Logger.info(`[Preload] Scheduling: ${route.path} (${delay}ms)`);

      return timer(delay).pipe(
        mergeMap(() => {
          Logger.info(`[Preload] Loading: ${route.path}`);
          return load();
        }),
      );
    }
    return of(null);
  }
}
